import { ApiResponse, ApisauceInstance } from 'apisauce'
import { DateTime } from 'luxon'
import { handleResponse } from '../handleResponse'

export const SubscriptionApi = {
  apisauce: {} as ApisauceInstance,

  async getProducts() {
    const response: ApiResponse<any> = await SubscriptionApi.apisauce.get(
      `/subscriptions/subscriptions/products/`,
    )
    return handleResponse(response)
  },

  async createProduct(product) {
    const response: ApiResponse<any> = await SubscriptionApi.apisauce.post(
      `/subscriptions/products/`,
      { ...product, vendor: SubscriptionApi.apisauce.headers['x-access-code'] },
    )
    return handleResponse(response)
  },

  async getProduct(id: number) {
    const response: ApiResponse<any> = await SubscriptionApi.apisauce.get(
      `/subscriptions/products/${id}/`,
    )
    return handleResponse(response)
  },

  async archiveProducts(product_ids: number[]) {
    const response: ApiResponse<any> = await SubscriptionApi.apisauce.post(
      `/subscriptions/products/archive/`,
      { product_ids },
    )
    return handleResponse(response)
  },

  async updateProduct(id, product) {
    if (product.tag_ids == null) {
      product.tag_ids = []
    }
    const response: ApiResponse<any> = await SubscriptionApi.apisauce.patch(
      `/subscriptions/products/${id}/`,
      { ...product, vendor: SubscriptionApi.apisauce.headers['x-access-code'] },
    )
    return handleResponse(response)
  },

  async getPurchases(productId?: number, userId?: number) {
    let response: ApiResponse<any>
    if (productId) {
      response = await SubscriptionApi.apisauce.get(
        `/subscriptions/purchases/?product_id=${productId}`,
      )
    } else if (userId) {
      response = await SubscriptionApi.apisauce.get(`/users/${userId}/purchases/`)
    } else {
      response = await SubscriptionApi.apisauce.get(`/subscriptions/purchases/`)
    }
    return handleResponse(response)
  },

  async getPurchase(id: number) {
    const response: ApiResponse<any> = await SubscriptionApi.apisauce.get(
      `/subscriptions/purchases/${id}/`,
    )
    return handleResponse(response)
  },

  async extendPurchases(purchase_ids: number[], expiration_date: string) {
    const response: ApiResponse<any> = await SubscriptionApi.apisauce.patch(
      `/subscriptions/purchases/extend/`,
      {
        purchase_ids,
        expiration_date: DateTime.fromFormat(expiration_date, 'yyyy-MM-dd hh:mm').toUTC().toISO(),
      },
    )
    return handleResponse(response)
  },

  async revokeSubscription(id) {
    const response: ApiResponse<any> = await SubscriptionApi.apisauce.post(
      `/subscriptions/${id}/revoke/`,
      {},
    )
    return handleResponse(response)
  },

  async testSubscription(
    product_ids: number[],
    user_ids: number[],
    user_emails: string[],
    duration_days: number | null,
  ) {
    const response: ApiResponse<any> = await SubscriptionApi.apisauce.post(`/subscriptions/test/`, {
      product_ids,
      user_ids,
      user_emails,
      duration_days,
    })
    return handleResponse(response)
  },

  async directInvite(product_ids: number[], user_emails: string[], duration_days: any) {
    const response: ApiResponse<any> = await SubscriptionApi.apisauce.post(
      `/subscriptions/invite-test/`,
      { product_ids, user_emails, duration_days },
    )
    return handleResponse(response)
  },

  async getUserSubscriptions(userId: number) {
    const response: ApiResponse<any> = await SubscriptionApi.apisauce.get(
      `/users/${userId}/purchases/`,
    )
    return handleResponse(response)
  },

  async getUserSubscriptionDetail(user_id: number, purchase_id: number) {
    const response: ApiResponse<any> = await SubscriptionApi.apisauce.get(
      `/users/${user_id}/purchases/${purchase_id}/`,
    )
    return handleResponse(response)
  },

  async getPurchaseAttempts(user_id: number, purchase_id: number) {
    const response: ApiResponse<any> = await SubscriptionApi.apisauce.get(
      `/users/${user_id}/purchases/${purchase_id}/attempts/`,
    )
    return handleResponse(response)
  },

  async reattemptPurchase(purchase_id: number) {
    const response: ApiResponse<any> = await SubscriptionApi.apisauce.post(
      `/subscriptions/purchases/${purchase_id}/reattempt/`,
    )
    return handleResponse(response)
  },

  async ahaWebhook(payload: any) {
    const response: ApiResponse<any> = await SubscriptionApi.apisauce.post(`/aha_webhook/`, payload)
    return handleResponse(response)
  },
}
